import React from "react";
import Card from "./Card";
import { business } from "../../data/data";

const AdminList = () => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-5 lg:gap-[30px] lg:mt-[55px]">
      {business?.length
        ? business?.map((elem, i) => <Card key={i} data={elem} />)
        : ""}
    </div>
  );
};

export default AdminList;
